<template>
    <LineChartComponent style="height: 250px" v-if="isShow" :chartID="'ChartPerStatus'" :chartData="chartData" :legendHandler="action_Legend" :legendsMaxLength="30" />
</template>

<script>
import LineChartComponent from '../Common/LineChart.vue'
import { sheetState } from '../../../../sheet-state'
import { monitorState, setSelectedStatus } from '../monitor-popup-state'
const moment = require('@/util/MPMoment')

export default {
    components: { LineChartComponent },
    data() {
        return {
            sheetState,
            monitor: monitorState,
        }
    },
    watch: {},
    computed: {
        isShow: function () {
            return this.monitor.selectedPerType == 'status'
        },
        headers: function () {
            return this.monitor.loadedStatus ?? []
        },
        selectedPeriodType: function () {
            return this.monitor.selectedPeriod.periodType
        },
        targetDateArray: function () {
            return this.monitor.targetDateArray
        },
        xTitle: function () {
            let getWeeksOfMonth = function (date) {
                let startOfMonth = moment(date).startOf('month')
                return Math.ceil((moment(date).date() + startOfMonth.day()) / 7)
            }
            let array = []

            for (let i = 0; i < this.targetDateArray.length; i++) {
                let time = moment(this.targetDateArray[i])
                let value = ''
                if (this.selectedPeriodType == 'day') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.label_datedaily'))
                }
                if (this.selectedPeriodType == 'week') {
                    let date = moment(time).endOf('week')
                    let weeksOfMonth = getWeeksOfMonth(date)
                    const mFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly')
                    const wFormatString = this.$t('reservationwindow.reservationmonitor.table_date_weekly_week')
                    value = date.format(mFormatString)
                    value += wFormatString.replace('{n}', weeksOfMonth)
                }
                if (this.selectedPeriodType == 'month') {
                    value = time.format(this.$t('reservationwindow.reservationmonitor.table_date_monthly'))
                }
                array.push(value)
            }
            return array
        },
        labels: function () {
            return this.headers.map((l) => l.title)
        },
        rawData: function () {
            return this.monitor.rawData
        },
        selectedCountType: function () {
            return this.monitor.selectedCountType
        },
        datasets: function () {
            let dateInRange = function (targetDate, start, end) {
                let t = moment(targetDate)
                let s = moment(start)
                let e = moment(end)
                if (t.isSameOrAfter(s) && t.isBefore(e)) {
                    return true
                }
                return false
            }
            let sets = []
            let key = this.selectedCountType == 'patients' ? 'sumHServiceCount' : 'sumReservationCount'
            for (let i = 0; i < this.headers.length; i++) {
                let header = this.headers[i]
                let statusID = header._id
                let data = []
                for (let ti = 0; ti < this.targetDateArray.length; ti++) {
                    let time = moment(this.targetDateArray[ti])
                    let endTime = moment(time)
                    if (this.selectedPeriodType == 'day') {
                        endTime = endTime.add(1, 'days')
                    }
                    if (this.selectedPeriodType == 'week') {
                        endTime = endTime.add(1, 'weeks')
                    }
                    if (this.selectedPeriodType == 'month') {
                        endTime = endTime.add(1, 'month')
                    }

                    let filteredData = this.rawData.filter((d) => d.statusID?._id == statusID && dateInRange(d.registerDate, time, endTime))
                    let sum = 0
                    for (let di = 0; di < filteredData.length; di++) {
                        let data = filteredData[di]
                        if (header.isCancelStatus == true) {
                            if (this.selectedCountType == 'patients') {
                                sum += data.cancelHServiceCount   
                            }
                            else {
                                sum += data.cancelReservationCount
                            }
                        }
                        else {
                            sum += data[key]
                        }
                    }
                    data.push(sum)
                }
                let localHeader = this.monitor.localStatus.find((c) => c._id == header._id)
                let set = {
                    label: header.title,
                    borderColor: this.getColor(header),
                    data: data,
                    hidden: !localHeader?.isSelected ?? true,
                    cubicInterpolationMode: 'monotone'
                }
                sets.push(set)
            }
            return sets
        },
        chartData: function () {
            let data = {
                labels: this.xTitle,
                datasets: this.datasets
            }
            return data
        },
        palette: function () {
            let reservationSetting = this.sheetState.reservationSetting
            let statusColorPaletteID = reservationSetting?.statusColorPaletteID
            return statusColorPaletteID.basicPalette
        }
    },
    methods: {
        action_Legend(_, item) {
            let index = item.datasetIndex
            if (index == undefined || index < 0) {
                return
            }
            let status = this.monitor.loadedStatus[index]
            setSelectedStatus(status, !item.hidden)
        },
        getColor(status) {
            let colorIndex = status.paletteIndex
            let color = this.palette[colorIndex]
            if (color == '#ffffff' || color == '#FFFFFF') {
                color = '#f0f0f0'
            }
            return color
        }
    }
}
</script>
